import { Helmet } from "react-helmet-async";
import {
  Container,
  Grid,
  Typography,
  Breadcrumbs,
  Link,
  Box,
  Button,
} from "@mui/material";
import { Link as RouterLink } from "react-router-dom";
import SubscriptionManagementTable from "src/components/dashboard/SubsctiptionManagement/SubscriptionManagementTable";
import ChevronRightIcon from "src/icons/ChevronRight";
import useSubscriptionManagement from "src/hooks/useSubscriptionManagement";

const SubscriptionManagementPage = () => {
  const { subscriptions, handleSubscriptionStatus, handleDeleteSubscription, isFreePlanActive, loadingStates } =
    useSubscriptionManagement();
  return (
    <>
      <Helmet>
        <title>APEXE3 Revolutions</title>
      </Helmet>
      <Container>
        <Grid position="relative" height="100vh" sx={{ py: 4, mt: 8 }}>
          <Grid item sx={{ display: "flex", justifyContent: "space-between" }}>
            <Box>
              <Typography color="textPrimary" variant="h5">
                Subscription Management
              </Typography>
              <Breadcrumbs
                aria-label="breadcrumb"
                separator={<ChevronRightIcon fontSize="small" />}
                sx={{ mt: 1 }}
              >
                <Link
                  color="textPrimary"
                  component={RouterLink}
                  to="/"
                  variant="subtitle2"
                >
                  Overview
                </Link>
                <Typography color="textSecondary" variant="subtitle2">
                  Subscriptions
                </Typography>
              </Breadcrumbs>
            </Box>
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "right",
                gap: 2,
                mt: 3,
              }}
            >
              <Button
                size="small"
                variant="outlined"
                sx={{ fontSize: "14px", borderRadius: "10px" }}
                href="/metered-subscription-plan"
              >
                Create Metered Plan
              </Button>
              <Button
                size="small"
                variant="outlined"
                sx={{ fontSize: "14px", borderRadius: "10px" }}
                href="/free-starter-plan"
              >
                Create Free Plan
              </Button>
            </Box>
          </Grid>
          <Grid item>
            <SubscriptionManagementTable
              subscriptions={subscriptions}
              handleDeleteSubscription={handleDeleteSubscription}
              handleSubscriptionStatus={handleSubscriptionStatus}
              isFreePlanActive={isFreePlanActive}
              loadingStates={loadingStates}
            />
          </Grid>
        </Grid>
      </Container>
    </>
  );
};

export default SubscriptionManagementPage;
